var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-regular-file-excel",
    "data-name": "Icon fa-regular-file-excel",
    d: "M1.5,14V2A.5.5,0,0,1,2,1.5H7V4A1,1,0,0,0,8,5h2.5v9a.5.5,0,0,1-.5.5H2A.5.5,0,0,1,1.5,14ZM2,0A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V4.828a2,2,0,0,0-.584-1.416L8.584.584A1.993,1.993,0,0,0,7.172,0ZM4.841,7.291a.75.75,0,1,0-1.184.922L5.05,10,3.659,11.791a.75.75,0,1,0,1.184.922L6,11.222l1.159,1.488a.75.75,0,0,0,1.184-.922L6.95,10,8.341,8.209a.75.75,0,0,0-1.184-.922L6,8.778,4.841,7.291Z",
    fill: "#027bc6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.8cd9dbc2eaccee7c1012f35474e344db.svg";
export { ForwardRef as ReactComponent };